import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSafety = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSafety",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m438-452-56-56q-12-12-28-12t-28 12-12 29 12 28l84 85q12 12 28 12t28-12l170-170q12-12 12-28t-12-29-28-12-29 12zm42 368-13-1-12-3q-135-45-215-166t-80-262v-189q0-25 15-45t37-29l240-90q14-5 28-5t28 5l240 90q23 9 38 29t14 45v189q0 140-80 262T505-88l-12 3z"
  })
}));